import type { PlanType } from './checkout.service';

/** Store product ids — must match App Store Connect / Play Console and RevenueCat. */
export const IAP_PRODUCT_IDS: Record<PlanType, string> = {
  jahrespass: 'ch.pickapeak.jahrespass',
  herbstpass: 'ch.pickapeak.herbstpass',
  einzelwanderung: 'ch.pickapeak.einzelwanderung',
};

/** RevenueCat offering package identifiers (match package setup in RevenueCat dashboard). */
export const IAP_PACKAGE_IDS: Record<PlanType, string> = {
  jahrespass: 'jahrespass',
  herbstpass: 'herbstpass',
  einzelwanderung: 'einzelwanderung',
};

/** Default RevenueCat offering identifier. */
export const IAP_DEFAULT_OFFERING = 'default';
